<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="promotion_page.list_title" />

    <PromotionList
      :promotions="filteredPromotions"
      :stats="stats"
      :loading="loading"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      :can-create="canCreatePromotion"
      :can-update="canUpdatePromotion"
      :can-delete="canDeletePromotion"
      :format-promotion-value="formatPromotionValue"
      :format-promotion-days="formatPromotionDays"
      :format-promotion-window="formatPromotionWindow"
      @update:search-query="searchQuery = $event"
      @create="openCreateModal"
      @edit="openEditModal"
      @delete="deletePromotion"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />

    <CreatePromotionModal
      :open="showModal"
      :is-edit="!!selectedPromotion"
      :form="form"
      :customers="customers"
      :errors="errors"
      :loading="loading"
      :can-create="canCreatePromotion"
      :can-update="canUpdatePromotion"
      :can-save="canSaveCurrentPromotion"
      @close="closeModal"
      @save="savePromotion"
      @generate-code="generatePromotionCode"
      @update-field="updateField"
      @toggle-day="toggleDay"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreatePromotionModal from "../../components/Settings/CreatePromotionModal.vue";
import PromotionList from "../../components/Settings/PromotionList.vue";
import { usePromotion } from "../../composables/usePromotion";

const {
  customers,
  searchQuery,
  filteredPromotions,
  stats,
  showModal,
  selectedPromotion,
  form,
  errors,
  loading,
  paginationConfig,
  fetchInitialData,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  generatePromotionCode,
  savePromotion,
  deletePromotion,
  canCreatePromotion,
  canUpdatePromotion,
  canDeletePromotion,
  canSaveCurrentPromotion,
  formatPromotionValue,
  formatPromotionDays,
  formatPromotionWindow,
} = usePromotion();

const toggleDay = (day: string) => {
  const nextDays = form.value.valid_days.includes(day)
    ? form.value.valid_days.filter((value) => value !== day)
    : [...form.value.valid_days, day];

  updateField("valid_days", nextDays);
};

onMounted(fetchInitialData);
</script>
